import React from 'react'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import DoneIcon from '@mui/icons-material/Done'
import CustomCheckboxField from '../../_common/_form_fields/CustomCheckboxField'
import constants from '../../../config/constants'
import useWindowDimensions from '../../_common/WindowDimesnions'

const SubscriptionServiceItem = (props) => {
  const {
    subscription_id,
    setSubscriptionPackages,
    service,
    title,
    checked,
    is_mandatory,
    price,
    currency,
  } = props
  const { width } = useWindowDimensions()

  const checkboxStyle = {
    color: 'white',

    '&.Mui-checked': {
      color: 'white',
    },

    '& .MuiSvgIcon-root': {
      fontSize: width >= constants.xlBreakpoint ? 28 : 24,
    },
  }

  const handleClickServiceCheckbox = (event) => {
    event.stopPropagation()
  }

  const handleChangeServiceChecked = (value) => {
    setSubscriptionPackages(prev => {
      let result = []

      prev.forEach(p => {
        if (p.id === subscription_id) {
          let new_services = []

          p.services.forEach(s => {
            if (s.service === service) {
              new_services.push({ ...s, checked: value })
            } else {
              new_services.push(s)
            }
          })

          result.push({ ...p, services: new_services })
        } else {
          result.push(p)
        }
      })

      return result
    })
  }

  const handleClickServiceTitle = (event) => {
    event.stopPropagation()
    
    setSubscriptionPackages(prev => {
      let result = []

      prev.forEach(p => {
        if (p.id === subscription_id) {
          let new_services = []

          p.services.forEach(s => {
            if (s.service === service) {
              new_services.push({ ...s, checked: !s.checked })
            } else {
              new_services.push(s)
            }
          })

          result.push({ ...p, services: new_services })
        } else {
          result.push(p)
        }
      })

      return result
    })
  }

  return (
    <Stack
      direction='row'
      alignItems='center'
      justifyContent='flex-start'
      sx={{
        width: '100%',
        marginLeft: width >= constants.mdBreakpoint ? '10%' : '2%',
        fontSize: width >= constants.xlBreakpoint ? '18px' : '16px',
      }}
    >
      <Box>
        {
          is_mandatory ?
          <DoneIcon
            fontSize='large'
            sx={{
              margin: width >= constants.xlBreakpoint ? '7px 20px 0px 0px' : '7px 16px 0px 0px',
            }}
          /> :
          <Box onClick={handleClickServiceCheckbox}>
            <CustomCheckboxField
              checked={checked}
              handleChange={handleChangeServiceChecked}
              sx={checkboxStyle}
            />
          </Box>          
        }
      </Box>
      <Box sx={{ paddingRight: '20px' }}>
        <Box component='span' onClick={handleClickServiceTitle}>{title.value}</Box>
        {
          !is_mandatory &&
          <>
            <Box component='span'> - {price} </Box>
            <Box component='span' sx={{ textTransform: 'uppercase' }}>{currency}</Box>
          </>
        }      
      </Box>
    </Stack>
  )
}

export default SubscriptionServiceItem